// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__DDMD3","popupContent":"Popup_popupContent__VKSMx"};